module.exports = __webpack_public_path__ + "static/media/moderna_lirio.8a464f24.png";